import { Component, OnInit, Input } from '@angular/core';
import { emptyFields, Country, UsersType, TransactionAccountTypes,
attachmentTypes, commentsType, attachmentCode, gstColumnName } from '../../utilities/common-file';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { countries } from '../../utilities/countries';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TransactionService } from '../transactions.service';
import { Observable, Observer } from 'rxjs';
import { CommonService } from 'src/app/utilities/common-service';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
})
export class RefundComponent implements OnInit {
    file:any;
    @Input() value: any;
    selectedTransaction: any;
    private selectedTab = 0;
    selectedIndex = 0;
    emptyField = emptyFields;
    country = Country;
    countries = countries;
    userRoles = UsersType;
    merchantDetails: any;
    refundForm: UntypedFormGroup;
    refundReasons = [];
    transactionAccountTypes = TransactionAccountTypes;
    loadingForRefund = false;
    fileList: NzUploadFile[] = [];
    attachmentData: any;
    attachmentList = [];
    deviceSignature = '';
    showFields = false;
    gst:any = localStorage.getItem('gst');
    hst:any = localStorage.getItem('hst');
    gstColumnName = gstColumnName;
    columnName :any;
  // tslint:disable-next-line: max-line-length
  constructor(
    private transactionService: TransactionService, 
    private commonService: CommonService, 
    private drawerRef: NzDrawerRef,
    private fb: UntypedFormBuilder, 
    private notification: NzNotificationService, 
    private modal: NzModalService,
    private authService: AuthService) {
    this.refundForm = this.fb.group({
      amount: new UntypedFormControl('', {
        validators: [Validators.required, Validators.pattern(/^\d*(?:[.,]\d{1,2})?$/)]
      }),
      reason: ['', Validators.required],
      notes: ['']
    });
  }
  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.selectedTransaction = this.value;
    this.selectedTab -= 1; 
    if( this.selectedTransaction.merchant && this.selectedTransaction.merchant.isRemittanceMerchant){ 
      this.refundForm.controls.amount.setValue(this.selectedTransaction.amount);
    }
    this.getMerchants();
    this.deviceSignature = this.authService.getDeviceSignature();
    this.showFields = this.authService.showOptionsBasedOnUserType();
}
getMerchants() {
    this.merchantDetails = this.authService.getMerchantDetails();
    if (this.merchantDetails) {
      if (this.merchantDetails.refundReasons && this.merchantDetails.refundReasons.length > 0) {
        this.refundReasons = this.merchantDetails.refundReasons;
      }
    }
  }
getCurrency(currency) {
  const index = this.countries.findIndex(M => M.currency_code ===  currency);
  if (index !== -1) {
      return this.countries[index].currency_symbol;
  }
}
tab(index: number) {
  this.selectedTab = index;
}
showConfirmation() {
  if (this.refundForm.valid) {
    if (this.refundForm.value.amount > 0) {
      if (this.refundForm.value.amount <= this.selectedTransaction.amount) {
        this.modal.confirm({
          nzTitle: 'Are you sure you want to refund this transaction?',
          nzOkText: 'Yes',
          nzOkType: 'danger',
          nzOnOk: () => this.refund(),
          nzCancelText: 'No',
          nzOnCancel: () => console.log('Cancel')
        });
       } else {
        this.notification.error('Entered amount should be less than or equal to Total transaction amount', '', {
          nzKey : 'key'
        });
       }
    } else {
      this.notification.error('Amount must be greater than 0', '', {
        nzKey : 'key'
      });
    }

   } else {
     // tslint:disable-next-line: forin
     for (const i in this.refundForm.controls) {
       this.refundForm.controls[i].markAsDirty();
       this.refundForm.controls[i].updateValueAndValidity();
     }
     this.notification.error('Please fill required fields', '', {
     nzKey : 'key'
   });
 }
}
refund() {
  this.loadingForRefund = true;
  const data = {
    transactionId: this.selectedTransaction.id,
    amount: this.refundForm.value.amount,
    deviceSignature: this.deviceSignature
  };
  this.transactionService.doRefund(data).subscribe((response: any) => {
    this.loadingForRefund = false;
    if (response && response.data && response.data.transactionId) {
      if (this.refundForm.value.notes) {
       this.addComments(response.data.transactionId);
      }
      if (this.attachmentList.length > 0) {
        this.addAttachments(response.data.transactionId);
      }
    }
    this.notification.success(response.message, '', {
      nzKey : 'key'
    });
    this.drawerRef.close(response);
  }, err => {
    this.loadingForRefund = false;
  });
}

getKycStatus(status) {
  return this.commonService.getKycStatus(status);
}
getTier(tier) {
  return this.commonService.getTier(tier);
}
getTransactionType(mode) {
  return this.commonService.getTransactionAccountType(mode);
}
addComments(transactionId) {
  const valueForComments = {
    comment: this.refundForm.value.notes,
    referenceId: transactionId,
    type: commentsType.transaction
  };
  this.commonService.createComments(valueForComments).subscribe((resComments: any) => {
  }, (errComments: any) => {
  });
}
addAttachments(transactionId) {                    // Upload api is calling by looping the array.
   for (const obj of this.attachmentList) {
     obj.append('referenceId',transactionId);
     this.commonService.uploadAttachmentsNew(obj).subscribe((response: any) => {
    }, err => {
      this.fileList = [];
      this.attachmentList = [];
    });
  }
}
beforeUploadAttachments = (file: NzUploadFile) => {   // Here upload api not calling we are pushing images to array.
  this.file='';
  this.file = file;
  this.fileList = this.fileList.concat(file);
  return new Observable((observer: Observer<boolean>) => {
    // this.getBase64(file as any, (img: string) => {
    //   if (file.type) {
    //     img = img.replace('data:' + file.type + ';base64,', '');
    //   }
    this.notification.info('File Upload Processing', 'Please Wait', {
      nzKey: 'key'
    }); 
      const data = new FormData();
      data.append('file',this.file);
      // data.append('referenceId', this.selectedTransactionId);
      data.append('type',attachmentTypes.transaction);
      data.append('code',attachmentCode.attachment);   
      //  const data = {
      //   imageType: file.type,
      //   imageBase64: img,
      //   code: 'attachment',
      //   type: attachmentTypes.transaction
      // };
      this.attachmentData = data;
      observer.next(this.attachmentData);
      observer.complete();
       this.attachmentList.push(this.attachmentData);
   // });
  });
}
private getBase64(img: File, callback: (img: string) => void): void {
  const reader = new FileReader();
  // tslint:disable-next-line: no-non-null-assertion
  reader.addEventListener('load', () => callback(reader.result!.toString()));
  reader.readAsDataURL(img);
}
close() {
  this.drawerRef.close();
}
}
